import Logo from "assets/images/logo_blue.png";
import NuWave from "assets/images/nav/nuwave_black.png";

//GOOGLE OAUTH
export const GOOGLE_CLIENT_ID='444691808577-2ok712r0f1umjrgl5ndo0s3rt08p7lii.apps.googleusercontent.com'
export const GOOGLE_SCOPE = "https://www.googleapis.com/auth/userinfo.email"

export const SentryDSN_DEV = ""
export const SentryDSN_PROD = "https://53de57189a184c5db40d1d7ea9394a96@o1167548.ingest.sentry.io/6258716"
export const SentryDSN_STG = "https://40343aed15d841c6b882b632552007ee@o1167548.ingest.sentry.io/6258777"

// Publishable key
export const StripeKey = 'pk_test_bowWtykmtAwZxvD0bvdXEycG00LczLxeDB'

export const Domain = {
    id: 1,
    name: "Innerlogic",
    url: "app.innerlogic.com",
    image: Logo
}

export const Environment = 'Production'
// app urls
export const serverUrl = "https://survey.innerlogic.com"
export const returnUrl = "https://app.innerlogic.com/account/login"
export const surveyUrl = "https://survey.innerlogic.com";

// auth login
// export const goAuthApiServer = 'https://auth.innerlogic.com' (removed on 1 may 2025)
// export const goAuthApiStaging = 'https://stg-auth-api.innerlogic.ca' (removed on 1 may 2025)

export const goAuthApiServer = 'https://auth.innerlogic-api.com'
export const goAuthApiStaging = 'https://stg-auth.innerlogic-api.com'

// django api
export const serverApi = "https://django-api.innerlogic-api.com"
// export const serverApi = 'https://api2.innerlogic.com'
// export const serverApi = 'https://api.innerlogic.com'

//report api
// export const reportProductionApi = "https://reports-api.innerlogic.ca"
export const reportStagingApi = "https://stg-reports-api.innerlogic.ca"
export const reportProductionApi = "https://reports-api-v2.innerlogic.ca"
export const reportLocalApi = "http://127.0.0.1:8000"
// ml api

export const mlProductionApi = "https://ml.innerlogic.ca"

// chat api
export const chatProductionApi = "https://ml-websocket.innerlogic.ca"
export const chatProductionApiV2a = "https://chat-api.innerlogic-api.com/api"

// websocket chat
export const wsProductionApi = "wss://ml-websocket.innerlogic.ca"
export const wsProductionApiV2a = "wss://chat-api.innerlogic-api.com"

// slack appi
export const slackProductionApi = "https://slack-bot.innerlogic.ca"

// powerpoint api
export const pptProductionApi = "https://powerpoint.innerlogic-api.com";

export const currentApi = serverApi;
export const curGoApi = goAuthApiServer;
export const mlApi = mlProductionApi
export const reportApi = reportProductionApi
export const chatApi = chatProductionApi;
export const wsApi = wsProductionApi;
export const chatApiV2 = chatProductionApiV2a;
export const wsApiV2 = wsProductionApiV2a
export const slackApi = slackProductionApi;
export const pptApi = pptProductionApi;
//
export const config = {
  	// switch to go for login
  	loginapi: `${curGoApi}`,
  	// use django api for login changed Oct 3 2022
  	// loginapi: `${currentApi}/api/account`,
  	signupapi: `${currentApi}/api/signup`,
  	// surveyapi: `${currentApi}/api/survey`,
  	appapi: `${currentApi}/api/organization`,
	reportApi,
  	// ML server
  	mlapi: `${mlApi}`,
  	// payment: `${currentApi}/api/payment`,
  	website: `${currentApi}/api/web`,
	surveyUrl,
	chatApi,
    	wsApi,
	chatApiV2,
	wsApiV2,
	slackApi,
	pptApi,
  };

export default config
